import { Component, TemplateRef, ViewChild } from '@angular/core';
import { messageService } from 'src/app/message.service';
import { qmsService } from '../qms.service';
import { DynamicGridConfig, DynamicGridClauses, DynamicGridReport, DynamicGridSettings, DynamicGridTrail } from 'src/app/support/models/dynamic-grid.model';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-quality-dependents',
  templateUrl: './quality-dependents.component.html',
  styleUrls: ['./quality-dependents.component.scss']
})

export class QualityDependentsComponent {

  isProcessing: boolean = false;
  idMapping: Record<string, string> = { '': '' };
  gridLength: any = [];

  constructor(readonly qualityService: qmsService, readonly message: messageService, readonly dialog: MatDialog) { }

  public openPopup(): void {
    this.gridLength = [];
    this.getCall();
    this.idMapping = { 'CR': this?.qualityService?.activity?.crId, 'CAPA': this.qualityService.activity.capaId, 'DV': this.qualityService.activity.dvId, 'IN': this.qualityService.activity.inId, 'QI': this.qualityService.activity.qiId, 'CC': this.qualityService.activity.ccId, 'AU': this.qualityService.activity.auId, 'OOS': this.qualityService.activity.oosId, };
    this.visibleDependentPopup = this.dialog.open(this.dependentPopup, this.addDependencyPopupConfig);
  }

  public closePopup(): void {
    this.visibleDependentPopup.close();
  }

  public onGridRefresh(event: any) {
    this.gridLength = event.length;
  }

  @ViewChild('dependentPopup', { static: true }) dependentPopup: TemplateRef<any>;
  private visibleDependentPopup: MatDialogRef<TemplateRef<any>>;

  private readonly addDependencyPopupConfig: MatDialogConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  gridConfig!: DynamicGridConfig;
  gridClause!: DynamicGridClauses;
  gridTrail!: DynamicGridTrail;
  gridReport!: DynamicGridReport;
  gridSettings!: DynamicGridSettings;

  getCall(): void {
    this.gridConfig = {
      gridName: 'PARENT_DEPENDENCY',
      groupId: 0,
      showAddButton: false,
      showEditIcon: false,
      showDeleteIcon: false,
      showReorderButton: false,
      showAuditTrail: false,
      buttonsTooltipSubName: '',
    };

    this.gridClause = {
      dependentRefNo: this.qualityService.activityId,
    };

    this.gridTrail = {
      gridName: 'PARENT_DEPENDENCY',
      refKey: 'REF_NO',
      trailName: `${this.qualityService.moduleName} Dependent Audit Trail ` + `[${this.idMapping[this.qualityService.moduleName]}]`
    };

    this.gridReport = {
      reportName: `${this.qualityService.moduleName} Dependent Report ` + `[${this.idMapping[this.qualityService.moduleName]}]`,
      reportType: 'Dynamic',
      excludeGroupId: true,
    };

    this.gridSettings = {
      module: this.qualityService.moduleName,
      groupId: 0
    };
  }

}
